export default () => undefined;
//# sourceMappingURL=noop.mjs.map